import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AdminRequestDto, AdminService } from 'src/generated_client';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.css']
})

export class LoginAdminComponent implements OnInit {

  loginAdminForm: FormGroup = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  })
  hidePassword: boolean = true;

  admin: AdminRequestDto = {} as AdminRequestDto;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private adminService: AdminService,
    private authService: AuthService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.authService.clearAuthState();
  }

  login(form: any) {

    this.admin = {
      dsUsername: form.username,
      dsPassword: form.password
    }

    this.adminService.apiAdminLoginPost(this.admin).subscribe(
      x => {
        this.authService.login(x);

        const initialRoute = this.getInitialRoute();
        this.router.navigateByUrl(initialRoute);
      },
      err => {
        this.toastr.error("Usuario o contraseña incorrectos");

        this.loginAdminForm.reset();
      }
    );
  }

  private getInitialRoute(): string {
    const { reDelivery, coopExpress } = environment.featureManagement;
    
    if (coopExpress && !reDelivery) {
      return 'particular-orders-list';
    }
    
    return 'admin-home';
  }
}
